import { createElement } from "react";
/**
 * WordPress Dependencies
 */
import { createContext, useMemo } from '@wordpress/element';
import { noop } from 'lodash';
const FormContext = createContext({
  formObj: {
    blocks: [],
    messages: {},
    theme: {},
    logic: undefined,
    themesList: [],
    settings: {
      disableProgressBar: false,
      disableWheelSwiping: false,
      animationDirection: 'vertical'
    },
    hiddenFields: {}
  },
  onSubmit: noop,
  isPreview: false
});
const FormContextProvider = ({
  children,
  value
}) => {
  const memoizedValue = useMemo(() => value, Object.values(value));
  return createElement(FormContext.Provider, {
    value: memoizedValue
  }, children);
};
export { FormContext, FormContextProvider };
//# sourceMappingURL=index.js.map